export default function (query) {
    let params = {};
    const listaQuery = query.split("?");

    for (var i = 0; i < listaQuery.length; i++) {
        if (listaQuery[i] !== "") {
            const listaParametro = listaQuery[i].split("&")

            for (var j = 0; j < listaParametro.length; j++) {
                var parametro = listaParametro[j].split("=");
                var key = parametro[0];
                var value = parametro[1];
                params[key] = value ? decodeURIComponent(value) : '';
            }
        }
    }

    //TODO - Otimizar o retorno do redirect_to(url completa vinda da aplicação) sem depender da posição do application_id
    let redirect = query.substring(query.indexOf('redirect_to'), query.indexOf('&application_id'));
    params['redirect_to'] = redirect.replace("redirect_to=", '');

    return params;

    // let params = {};

    // let redirect = query.substring(query.indexOf('redirect_to'), query.indexOf('&application_id'));
    // params['redirect_to'] = redirect.replace("redirect_to=", '');
    // let application = query.substring(query.indexOf('&application_id') + 1);
    // params['application_id'] = application.replace('application_id=','');

    // let token = query.substring(query.indexOf('token'));
    // params['token'] = token.replace("token=", '');
    // let step_recuperate  = query.substring(query.indexOf('step_recuperate' ), query.indexOf('&token'));
    // params['STEP_RECUPERATE'] = step_recuperate.replace("STEP_RECUPERATE=", '');

    // let key = query.substring(query.indexOf('key'));
    // params['key'] = key.replace("key=", '');
    // let step_recover_password = query.substring(query.indexOf('step_recover_password'), query.indexOf('key'));
    // params['STEP_RECOVER_PASSWORD'] = step_recover_password;

    // return params;

}